import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';

import {store} from './redux/store';
import {Layout} from './layout';

import './index.css';

import '@fontsource/montserrat';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <Layout/>
    </Provider>
);
